import inertElementsBehindOverlay from '../shared/mando-ui.inertElementsBehindOverlay';

const classesActivatingOverlay = ['is-menu', 'is-search'];
const activeOverlayAttribute = 'data-overlay';

function setObserver() {
  const body = document.querySelector('body'),
    options = {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    },
    observer = new MutationObserver(callback);

  function callback(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'attributes') {
        const bodyClasses = [...mutation.target.classList];
        const showOverlay = bodyClasses.some((item) => classesActivatingOverlay.includes(item));

        toggleOverlay(body, showOverlay);
      }
    }
  }
  observer.observe(body, options);
}

function toggleOverlay(body, showOverlay) {
  if (showOverlay) {
    body.setAttribute(activeOverlayAttribute, true);
    inertElementsBehindOverlay(true, '.js-overlay-inert');
  } else {
    body.removeAttribute(activeOverlayAttribute);
    inertElementsBehindOverlay(false, '.js-overlay-inert');
  }
}

function init() {
  setObserver();
}

export default init;
